<template>
  <div class="app-wrapper">
    <Navigation v-if="showNavigation" />
    <div class="app-content">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from './stores/auth';
import { useSessionKeepAlive } from './composables/useSessionKeepAlive';
import Navigation from './components/Navigation.vue';

const route = useRoute();
const authStore = useAuthStore();

const isAuthenticated = computed(() => authStore.isAuthenticated);
const showNavigation = computed(() => isAuthenticated.value && !route.path.startsWith('/scans/'));

// Initialize session keep-alive to prevent CSRF token mismatch
if(isAuthenticated.value) {
  useSessionKeepAlive();
}

// Removed onMounted auth fetch - router guard handles this
// Public pages: /, /about, /pricing, /contact don't need auth checks
</script>

<style>
.app-wrapper {
  min-height: 100vh;
  background: var(--bg-gray);
}

.app-content {
  min-height: 100vh;
}
</style>
